module.exports = __webpack_public_path__ + "img/inactive-21.8a977784.svg";